import { DataSource, DataSourceExecutionEvent, DataSourceMode } from "@mcleod/components";
import { ModelRow, UserSettings } from "@mcleod/core";
import { AutogenLayoutAdditionalDetailsLTLUnauthenticated } from "./autogen/AutogenLayoutAdditionalDetailsLTLUnauthenticated";

export class AdditionalDetailsLTLUnauthenticated extends AutogenLayoutAdditionalDetailsLTLUnauthenticated {
    private orderId: string;

    /** This is an event handler for the afterExecution event of sourceCustomerOrderDetail.  */
    sourceCustomerOrderDetailAfterExecution(event: DataSourceExecutionEvent) {
        if (UserSettings.isUserTypeLocation() && event.dataSource.activeRow?.get("is_asset_ltl"))
            this.panelBilling.visible = true;

        if (event.dataSource.activeRow?.get("is_br_ltl"))
            this.panelCarrier.visible = true;
        
        const row = event.dataSource.activeRow as ModelRow;
        this.tableReferenceNumbers.dataSource = new DataSource();
        this.populateDataSource(row.get("reference_numbers"), this.tableReferenceNumbers.dataSource);
    }

    private populateDataSource(data: [], dataSource: DataSource) {
        dataSource.setRowsAndMode(DataSourceMode.NONE, data?.map(data => new ModelRow(dataSource.url, false, data)) ?? []);
    }
}
